// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-detailed-container {
  width: 100%;
  background: #fafafa;
  min-height: 100vh;
}

.arrow-icon-left {
  text-align: left;
  margin-left: 30px;
  display: flex;
}

.arrow-icon-left svg {
  width: 35px;
  height: 35px;
}

.header-user-detail {
  width: 100%;
  height: 70px;
  background-color: #ff7d4d;
  color: #fff;
  font-size: 20px;
  display: flex;
  align-items: center;
  font-weight: bold;
}

.header-texthead {
  text-align: center;
  width: 100%;
}

.user-detail-text {
  color: #333333;
  font-size: 16px;
  padding: 5px;
}

.recipes-detail-box {
  min-width: 200px;
  max-width: 250px;
  height: 80px;
  background: #ffffff;
  border: 1px solid #9e9e9e;
  border-radius: 10px;
}

.user-details-bigBox {
  width: 100%;
  height: 100px;
  background: #ffffff;
  border: 1px solid #9e9e9e;
  border-radius: 10px;
}

.user-details-bigBox .flex-center-column{
  gap: 16px;
}

.sub-heading-user {
  color: #333333;
  font-size: 30px;
  text-align: left;
  line-height: 20px;
  padding: 5px;
}

/* Overlay to disable background scrolling */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden; /* Prevents page scroll */
  z-index: 1000;
}

/* Modal dialog styling */
.modal-dialog {
  background: white;
  border-radius: 10px;
  padding: 20px;
  max-width: 400px;
  width: 90%;
  max-height: 70%; /* Restrict height */
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* Scrollable content within modal */
.modal-content {
  overflow-y: auto; /* Enables scrolling inside the modal */
  margin-top: 10px;
  max-height: 50vh; /* Limit height for scrolling */
}

.option {
  padding: 10px;
  border: 1px solid #ccc;
  margin-bottom: 10px;
  background: #f3f3f3;
  text-align: center;
}

.close-button {
  margin-top: 20px;
  padding: 10px;
  background: #ff5e57;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.recipes-detail-box .flex-center-column{
  gap: 16px;
}`, "",{"version":3,"sources":["webpack://./src/Assets/UserDetails.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA,4CAA4C;AAC5C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB,EAAE,yBAAyB;EAC3C,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,eAAe,EAAE,oBAAoB;EACrC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA,oCAAoC;AACpC;EACE,gBAAgB,EAAE,uCAAuC;EACzD,gBAAgB;EAChB,gBAAgB,EAAE,+BAA+B;AACnD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAS;AACX","sourcesContent":[".user-detailed-container {\r\n  width: 100%;\r\n  background: #fafafa;\r\n  min-height: 100vh;\r\n}\r\n\r\n.arrow-icon-left {\r\n  text-align: left;\r\n  margin-left: 30px;\r\n  display: flex;\r\n}\r\n\r\n.arrow-icon-left svg {\r\n  width: 35px;\r\n  height: 35px;\r\n}\r\n\r\n.header-user-detail {\r\n  width: 100%;\r\n  height: 70px;\r\n  background-color: #ff7d4d;\r\n  color: #fff;\r\n  font-size: 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  font-weight: bold;\r\n}\r\n\r\n.header-texthead {\r\n  text-align: center;\r\n  width: 100%;\r\n}\r\n\r\n.user-detail-text {\r\n  color: #333333;\r\n  font-size: 16px;\r\n  padding: 5px;\r\n}\r\n\r\n.recipes-detail-box {\r\n  min-width: 200px;\r\n  max-width: 250px;\r\n  height: 80px;\r\n  background: #ffffff;\r\n  border: 1px solid #9e9e9e;\r\n  border-radius: 10px;\r\n}\r\n\r\n.user-details-bigBox {\r\n  width: 100%;\r\n  height: 100px;\r\n  background: #ffffff;\r\n  border: 1px solid #9e9e9e;\r\n  border-radius: 10px;\r\n}\r\n\r\n.user-details-bigBox .flex-center-column{\r\n  gap: 16px;\r\n}\r\n\r\n.sub-heading-user {\r\n  color: #333333;\r\n  font-size: 30px;\r\n  text-align: left;\r\n  line-height: 20px;\r\n  padding: 5px;\r\n}\r\n\r\n/* Overlay to disable background scrolling */\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  overflow: hidden; /* Prevents page scroll */\r\n  z-index: 1000;\r\n}\r\n\r\n/* Modal dialog styling */\r\n.modal-dialog {\r\n  background: white;\r\n  border-radius: 10px;\r\n  padding: 20px;\r\n  max-width: 400px;\r\n  width: 90%;\r\n  max-height: 70%; /* Restrict height */\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n/* Scrollable content within modal */\r\n.modal-content {\r\n  overflow-y: auto; /* Enables scrolling inside the modal */\r\n  margin-top: 10px;\r\n  max-height: 50vh; /* Limit height for scrolling */\r\n}\r\n\r\n.option {\r\n  padding: 10px;\r\n  border: 1px solid #ccc;\r\n  margin-bottom: 10px;\r\n  background: #f3f3f3;\r\n  text-align: center;\r\n}\r\n\r\n.close-button {\r\n  margin-top: 20px;\r\n  padding: 10px;\r\n  background: #ff5e57;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n}\r\n\r\n.recipes-detail-box .flex-center-column{\r\n  gap: 16px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
